import { getSession } from '../../../store/selectors/user.selectors';
import { TxSession } from '../../../shared/interfaces/session';
import { FetchMessages, MarkMessagesRead, MarkMessageUnread } from '../../../store/actions/message-center.actions';
import { getUnreadMessageCount } from '../../../store/selectors/user.selectors';
import { take } from 'rxjs/operators';
import { MessageCenterService } from '../../../shared/services/message-center.service';
import { getUserMessageList } from '../../../store/selectors/message-center.selectors';
import { State } from '../../../store/reducers/user-state.reducer';
import { Store } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { Component, ViewChild, AfterViewInit, Input } from '@angular/core';
import { MessageEntity } from '../../../store/entities/MessageEntity';
import { TxChatComponent } from '../../tx-chat/tx-chat.component';

@Component({
	selector: 'tx-messagecenter-client',
	templateUrl: './tx-messagecenter-client.component.html',
	styleUrls: ['./tx-messagecenter-client.component.scss'],
})
export class TxMessageCenterClientComponent implements AfterViewInit {
	@Input()
	public fullHeight = false;

	public Messages$: Observable<MessageEntity[]>;

	public Type: string;
	public Message: string;
	public AnswerMessage: MessageEntity;

	public WithArchived = false;

	public CurrentUser$: Observable<TxSession>;

	public height = 600;

	/** Set once the user manually marked a message unread, see markMessageUnread. */
	private skipAutoRead = false;

	@ViewChild('chat') private chat: TxChatComponent;

	constructor(private readonly store: Store<State>, private readonly service: MessageCenterService) {
		this.Messages$ = store.select(getUserMessageList).pipe(
			tap((msgs) => {
				this.markConversationRead(msgs);
				setTimeout(() => {
					this.scrollToBottom();
				}, 100);
			})
		);
		this.CurrentUser$ = store.select(getSession);
	}

	ngAfterViewInit(): void {
		this.checkForFullHeight();
	}

	checkForFullHeight() {
		if (this.fullHeight) {
			setTimeout(() => {
				this.height = window.screen.availHeight - 223 - (this.AnswerMessage ? 58 : 0);
			});
		}
	}

	scrollToBottom(): void {
		try {
			this.chat.scrollToBottom();
			// this.messagesContainer.nativeElement.scrollTo(0, this.messagesContainer.nativeElement.scrollHeight);
		} catch (err) {}
	}

	sendMessage(message: string, answer: MessageEntity) {
		this.service.sendMessage(0, message, 0, answer);

		this.Type = null;
		this.Message = null;
		this.AnswerMessage = null;
	}

	/**
	 * Marks the messages the employee just looked at as read.
	 *
	 * Mirror of the personal office version, with two differences: "incoming" is the opposite
	 * direction here (`target_persnr !== 0` — addressed to the employee rather than to the office),
	 * and the unread count comes from user.unread_messages (getUserInfo) instead of the message
	 * head, because that is what feeds this view's badge.
	 *
	 * Only the newest N are marked so the backlog from before this feature stays untouched.
	 */
	private markConversationRead(messages: MessageEntity[]) {
		if (this.skipAutoRead || !messages?.length) {
			return;
		}

		this.store
			.select(getUnreadMessageCount)
			.pipe(take(1))
			.subscribe((unreadCount) => {
				if (!unreadCount || unreadCount <= 0) {
					return;
				}

				const ids = messages
					.filter((message) => message.target_persnr !== 0)
					.sort((a, b) => new Date(b.creation_date).getTime() - new Date(a.creation_date).getTime())
					.slice(0, unreadCount)
					.map((message) => message.id);

				if (ids.length) {
					this.store.dispatch(MarkMessagesRead(0, ids));
				}
			});
	}

	markMessageUnread(message: MessageEntity) {
		// Blocks the auto-marking above, which would otherwise read the message straight back once
		// the refreshed counter arrives. Stays blocked until this view is rebuilt.
		this.skipAutoRead = true;
		this.store.dispatch(MarkMessageUnread(0, message.id));
	}

	archiveMessage(element: MessageEntity, remove: boolean = false) {
		this.service.archiveMessage(element.id, 0, this.WithArchived, remove);
	}

	refresh() {
		this.store.dispatch(FetchMessages(0, this.WithArchived));
	}
}
